import { makeAutoObservable } from 'mobx';
import { validateFtfc } from './validateFtfc';

export class FtfcData {
  timeFrames = [];

  constructor(initialData) {
    makeAutoObservable(this);
    if (initialData) {
      Object.keys(initialData).forEach(
        (field) => (this[field] = initialData[field])
      );
    }
  }

  //common methods
  resetToDefaults = () => {
    this.timeFrames = [];
  };

  updateTactic = (dataObj) => {
    for (const key in dataObj) {
      this[key] = dataObj[key];
    }
  };

  validate = (tradePlan) => {
    const data = {
      timeFrames: this.timeFrames,
      tradePlan,
    };
    const result = validateFtfc(data);
    return result;
  };

  returnJson = () => {
    return {
      timeFrames: this.timeFrames,
    };
  };

  //specific methods
  addTimeFrame = (timeFrame) => {
    if (
      !this.timeFrames.some(
        (item) =>
          item.timeUnit === timeFrame.timeUnit &&
          item.candleDuration === timeFrame.candleDuration
      )
    )
      this.timeFrames.push(timeFrame);
  };
  removeTimeFrame = (index) => {
    const newArr = this.timeFrames.filter((_item, i) => i !== index);
    this.timeFrames = newArr;
  };
  clearTimeFrames = () => {
    this.timeFrames = [];
  };
}
